export default __webpack_public_path__ + "static/media/mc_remove_tube_icon.9c1d0026.svg";